import axios from 'axios'
import * as CONFIG from '../config/index'
import * as helper from './helper'

export const SCORING_RESULT_API_URL = `${CONFIG.API_URL}/scoring-result`

export const getByPeriod = async (periodCode) => {
  try {
    const result = await axios.get(`${SCORING_RESULT_API_URL}/get-by-period?period=${periodCode}`);
    return result.data.data;
  } catch (e) {
    helper.notifyError(e);
    return [];
  }
}

export const update = async (form) => {
  try {
    const result = await axios.put(SCORING_RESULT_API_URL, form);
    helper.successMsg('Cập nhật thành công');
  } catch (e) {
    helper.notifyError(e);
  }
}

export const publish = async (form) => {
  try {
    const result = await axios.post(`${SCORING_RESULT_API_URL}/publish`, form);
    helper.successMsg('Cập nhật thành công');
  } catch (e) {
    helper.notifyError(e);
  }
}

export default {
  getByPeriod,
  update,
  publish
}



// WEBPACK FOOTER //
// ./src/common/scoringResult.js